<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import { useAnchor } from '~/composables/anchor'
import { useStickyObserver } from '~/composables/sticky-observer'
import Page from '~/enums/page'
import formatter from '~/helpers/formatter'
import { useCartStore } from '~/store/cart'

const cartStore = useCartStore()

useAnchor()
const { isHidden } = useStickyObserver('cart-next-button')
</script>

<template>
  <div
    v-if="!cartStore.isDataLoading && cartStore.cartProductsData.length"
    class="
      fixed inset-x-0 bottom-[54px] z-[9999] w-full bg-white px-3 pb-3 pt-2 shadow-[0_-4px_13px_0_rgba(0,0,0,0.25)]
      transition-all duration-500 ease-in-out sm:hidden
    "
    :class="{ 'translate-y-full opacity-0': isHidden, 'translate-y-0 opacity-100': !isHidden }"
  >
    <div class="mb-2 flex items-center justify-between">
      <a class="flex items-center !no-underline" href="#anchor3">
        <span class="mr-0.5 inline-block text-main-green">К деталям заказа</span>

        <svg fill="none" height="5" viewBox="0 0 8 5" width="8" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.0625 0.689941L4.0625 3.68994L7.0625 0.689941" opacity="0.3" stroke="#59AD3B"/>
        </svg>
      </a>

      <b
        class="text-base font-medium text-black transition-opacity duration-500"
        :class="{ 'opacity-0': !cartStore.totalInKopecks, 'opacity-100': cartStore.totalInKopecks }"
      >
        Итого&nbsp;{{ formatter.formatPrice(cartStore.totalInKopecks, true) }}&nbsp;₽
      </b>
    </div>

    <BasicButton
      class="!h-[56px] w-full"
      color="green"
      :title="'Перейти к\xA0оформлению'"
      @click="navigateTo(Page.Checkout)"
    />
  </div>
</template>
